import { action, makeObservable, observable } from 'mobx';

import { IAccessibilityStore } from '../IAccessibilityStore';

export class PictureBlockStore implements IAccessibilityStore {
  isPictureBlock = false;

  constructor() {
    makeObservable(this, {
      isPictureBlock: observable,
      togglePictureBlock: action.bound,
    });
  }

  togglePictureBlock() {
    this.isPictureBlock = !this.isPictureBlock;
  }

  reset() {
    this.isPictureBlock = false;
  }
}
